import { Box, Typography } from '@mui/material';
import * as React from 'react';
import { Question } from '../../types/questionnaire.types';
import { DadosServidorHeader } from './DadosServidor';

interface QuestionFormHeaderProps {
  questions: Question[];
  responses: Record<string, string>;
  currentQuestion?: number;
  onStepClick?: (index: number) => void;
  // children?: React.ReactNode;
}

export const QuestionFormHeader: React.FC<QuestionFormHeaderProps> = ({
  questions,
  responses,
  currentQuestion,
  onStepClick,
  // children,
}) => {
  return (
    <Box>
      <Box
        sx={{
          background:
            'linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important',
          borderRadius: '8px !important',
          p: 1,
          mb: 5,
          mt: 14,
          ml: { xs: 2, md: 5 },
          mr: { xs: 2, md: 5 },
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Typography
          sx={{
            color: '#ffffff !important',
            fontSize: { xs: '11pt', md: '12pt' },
            fontFamily: 'Roboto-Bold !important',
            letterSpacing: '0.8px !important',
            textTransform: 'uppercase !important',
            position: 'relative',
            zIndex: 1,
          }}
        >
          EXAM
        </Typography>
      </Box>
      <DadosServidorHeader
        questions={questions}
        responses={responses}
        currentQuestion={currentQuestion}
        onStepClick={onStepClick}
      />
      <Box sx={{ mt: 5 }} />
      {/* <Zoom in timeout={500}>
        <Box sx={{ ml: 2, mr: 2, pt: 1 }}>
          <Box
            sx={{
              mt: 2,
              mx: 'auto',
              maxWidth: 1400,
              border: '1px solid #F0F0F0',
              borderRadius: '12px !important',
            }}
          >
            <Box sx={{ p: 3 }}>{children}</Box>
          </Box>
        </Box>
      </Zoom> */}
    </Box>
  );
};
